import { render } from "./VideoManager.vue?vue&type=template&id=a1c814b4"
import script from "./VideoManager.vue?vue&type=script&lang=js"
export * from "./VideoManager.vue?vue&type=script&lang=js"

import exportComponent from "/home/kreativ-mobil.com/application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__